import { Suspense } from 'react';
import AppLoader from './loader/app-loader';

// LOADABLE - LAZY LOADING

const Loadable = (Component) => (props) => (
  <Suspense fallback={<AppLoader sx={{ minHeight: '60vh' }} />}>
    <Component {...props} />
  </Suspense>
);

export default Loadable;
